/**
 * APIキー作成ページ
 *
 * 新しいAPIキーを作成するフォーム。
 */

import { useForm, Head, Link } from '@inertiajs/react'
import type { FormEvent } from 'react'
import { HabitLayout } from '@/components/habits/HabitLayout'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { settings_api_keys_path } from '@/lib/routes'
import type { PageProps } from '@/types'

export default function ApiKeysNew(_props: PageProps) {
  const { data, setData, post, processing, errors } = useForm({
    api_key: {
      name: '',
    },
  })

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault()
    post(settings_api_keys_path())
  }

  return (
    <>
      <Head title="APIキー作成 | Init Habit" />

      <HabitLayout title="APIキー作成">
        <div className="mx-auto max-w-xl">
          {/* 戻るリンク */}
          <div className="mb-4">
            <Link
              href={settings_api_keys_path()}
              className="text-muted-foreground hover:text-foreground text-sm"
            >
              ← APIキー一覧に戻る
            </Link>
          </div>

          <div className="bg-card border-border rounded-xl border p-6">
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <Label htmlFor="name" className="text-base font-medium">
                  キー名
                </Label>
                <p className="text-muted-foreground mb-3 text-sm">
                  このAPIキーの用途がわかる名前をつけてください（例:
                  ChatGPT連携）
                </p>
                <Input
                  id="name"
                  type="text"
                  value={data.api_key.name}
                  onChange={(e) =>
                    setData('api_key', {
                      ...data.api_key,
                      name: e.target.value,
                    })
                  }
                  placeholder="ChatGPT連携"
                  required
                />
                {errors['api_key.name'] && (
                  <p className="text-destructive mt-1 text-sm">
                    {errors['api_key.name']}
                  </p>
                )}
              </div>

              <div className="flex justify-end gap-3">
                <Link href={settings_api_keys_path()}>
                  <Button type="button" variant="outline">
                    キャンセル
                  </Button>
                </Link>
                <Button type="submit" disabled={processing}>
                  {processing ? '作成中...' : 'APIキーを作成'}
                </Button>
              </div>
            </form>
          </div>
        </div>
      </HabitLayout>
    </>
  )
}
